import React from "react";
import DetailsBlockItem from "../DetailsBlockItem";

const DetailsBlock = ({
  isDetailsSectionFetching,
  detailsContent,
  detailsSectionIndex,
  detailsSubSectionIndex,
  isDesktopDevice,
  isMobileDevice,
  isTabletDevice,
  detailsToc,
  slugPubtype,
  slugTitle,
  detailsSectionCache,
  sectionMap,
  selectedReferences,
  drugConsultUrlTemplate,
  dispatch,
  telemetryData,
}) => {
  return (
    <DetailsBlockItem
      isDetailsSectionFetching={isDetailsSectionFetching}
      detailsContent={detailsContent}
      detailsSectionIndex={detailsSectionIndex}
      detailsSubSectionIndex={detailsSubSectionIndex}
      isDesktopDevice={isDesktopDevice}
      isMobileDevice={isMobileDevice}
      isTabletDevice={isTabletDevice}
      detailsToc={detailsToc}
      slugPubtype={slugPubtype}
      slugTitle={slugTitle}
      detailsSectionCache={detailsSectionCache}
      sectionMap={sectionMap}
      selectedReferences={selectedReferences}
      drugConsultUrlTemplate={drugConsultUrlTemplate}
      dispatch={dispatch}
      telemetryData={telemetryData}
    />
  );
};

DetailsBlock.displayName = "DetailsBlock";

export default DetailsBlock;
